import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("voir le maître")

import BaseForm from "@/domains/app/components/Form.vue";
import { FormParams } from "@/domains/app/forms";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useDogForm } from "../forms";
import { computed } from "@vue/reactivity";
import { useUser } from "@/domains/auth/user";
import { ABILITY_READ_RESTRICTED_CRUDS } from "../../users/users";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as { id: number | undefined }



let { formArgs: f1, data } = useDogForm(props.id);
const router = useRouter();
const user = useUser().user;

const formArgs = ref<FormParams>();
formArgs.value = f1;

const masterUrl = computed(() => {
    if (
        data.value?.master_id === -1 ||
        !data.value?.master_id ||
        !user.value?.abilities?.includes(ABILITY_READ_RESTRICTED_CRUDS)
    )
        return "";
    return router.resolve({
        name: "users.edit",
        params: { id: data.value?.master_id },
    }).href;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BaseForm, _normalizeProps(_guardReactiveProps(formArgs.value)), {
    footer: _withCtx(() => [
      (_unref(masterUrl))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _unref(masterUrl),
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}
}

})